import { get } from 'lodash'

/**
 * The v1 API returns list payloads in three different shapes, depending on how the
 * controller calls sendSuccess:
 *
 *   1. `sendSuccess(req, res, next, rows, 200, [], true)` with a bare array
 *      -> the body IS the array          (shared member-types / titles / designations / departments)
 *   2. `sendSuccess(req, res, next, rows)`
 *      -> `{ status, message, data: rows }`                      (member-status, countries, regions)
 *   3. `sendSuccess(req, res, next, { data, pagination }, 200, [], true)`
 *      -> `{ status, message, data: rows, pagination }`          (most paginated admin lists)
 *
 * Reading `data.data` only handles the last two, which is why member types came back
 * empty. This normalizes all three to a plain array.
 */
export default function unwrapList(request) {
  const body = get(request, 'data')

  if (Array.isArray(body)) return body

  const data = get(body, 'data')
  if (Array.isArray(data)) return data

  const nested = get(data, 'data')
  if (Array.isArray(nested)) return nested

  return []
}
